import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { GraphComponent } from './components/main/graph/graph.component';
import { MainComponent } from './components/main/main.component';
import { TestComponent } from './components/test/test.component';
import { UploadsComponent } from './components/uploads/uploads.component';

const routes: Routes = [
  {
    path: 'callback', component: OktaCallbackComponent,
  },
  { path: '', component: MainComponent, 
    children: [
      { path: '', component: GraphComponent },
      { path: 'home', component: GraphComponent },
      { path: 'uploads_sr', component: UploadsComponent },
      { path: 'uploads_ar', component: UploadsComponent },
      { path: 'uploads_sped', component: UploadsComponent },
      { path: 'uploads_er', component: UploadsComponent },
      { path: 'uploads_all', component: UploadsComponent },
    ],
    canActivate:[OktaAuthGuard]
  },
  {
    path: 'test', component: TestComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
